var app = angular.module('wealth-desk', ['ngRoute', 'angular.filter', 'ngAnimate', 'ngMessages', 'ngSanitize', 'ui.bootstrap', 'ngSentry', 'oc.lazyLoad']);

app.config(['$routeProvider', '$locationProvider', function ($routeProvider, $locationProvider) {

    $locationProvider.html5Mode(true);
    const authCheckAndHandler = function ($location, sessionService, WdHttpService) {

        if (!sessionService.isLoggedIn() && !$location.search().token) {
            $location.url('/register-client?returnToken=true&path=' + $location.absUrl());
        } else if ($location.search().token) {
            let token = $location.search().token;
            sessionService.set('refresh', token);

            var data = { 'refreshToken': token };
            WdHttpService._refresh_token(data, true)
                .then(async function (response) {
                    setUserSession(sessionService, response);
                    WdHttpService._cognito_profile(false);
                })
                .catch(async function (error) {
                    console.log(error);
                    $scope.showErrorPopup('Sorry, we failed to authenticate you.', () => { window.location.href = '/'; });
                });
        }
    };
    $routeProvider
        .when('/index.html', {
            redirectTo: "/"
        })
        .when('/', {
            resolve: {
                auth: function ($location, sessionService) {
                    if (sessionService.isLoggedIn()) {
                        return $location.path('/fund-discovery');
                    }
                }
            },
            templateUrl: "views/home.html",
            controller: "HomeController",
        })
        .when('/home', {
            redirectTo: "/"
        })
        .when('/kyc', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/kyc.html",
            controller: "KycController"
        })
        .when('/contact-us', {
            templateUrl: "views/contact-us.html",
            controller: "ContactUsController",
        })
        .when('/register-client', {
            templateUrl: "views/register-client.html",
            controller: "RegisterClientController"
        })
        .when('/forgot-password', {
            templateUrl: "views/forgot-password.html",
            controller: "ForgotPasswordController"
        })
        .when('/reset-password', {
            templateUrl: "views/reset-password.html",
            controller: "ResetPasswordController"
        })
        .when('/resetpassword-success', {
            templateUrl: "views/resetpassword-success.html",
            controller: "ResetPassSuccessController"
        })
        .when('/subscribe/:adviserUsername/:fund', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/kyc-thanku.html",
            controller: "KycThankuController"
        })
        .when('/adviser-agreement/:adviserUsername/:fundName', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/agreement.html",
            controller: "RiaAgreementController"
        })
        .when('/my-transactions', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/my-transactions.html",
            controller: "TransactionController",
        })
        .when('/payment/:orderId', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/payment.html",
            controller: "PaymentController"
        })
        .when('/payment/:orderId/:mode', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/payment.html",
            controller: "PaymentController"
        })
        .when('/payment', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/payment.html",
            controller: "PaymentController"
        })
        .when('/fund-details/:fundname', {
            redirectTo: "/wealthbaskets/:fundname"
        })
        .when('/wealthbaskets/:fundname', {
            templateUrl: "views/fund-details.html",
            controller: "FundDetailsController"
        })
        .when('/wealthbasket/:fundname', {
            redirectTo: "/wealthbaskets/:fundname"
        })
        .when('/faq', {
            templateUrl: "views/faq.html",
            controller: "FAQController"
        })
        .when('/user-performance/:adviser/:fund', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/user-performance.html",
            controller: "UserPerformanceController"
        })
        .when('/orderbook/:mode', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/orderbook.html",
            controller: "OrderBookController"
        })
        .when('/upload-trades', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/upload-trades.html",
            controller: "UploadTradesController"
        })
        .when('/fund-discovery', {
            redirectTo: "/wealthbaskets"
        })
        .when('/wealthbaskets', {
            templateUrl: "views/fund-discovery.html",
            controller: "FundDiscoveryController"
        })
        .when('/broker-login', {
            redirectTo: "/register-client"
        })
        .when('/login', {
            redirectTo: "/register-client"
        })
        .when('/profile', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/profile.html",
            controller: "ProfileController"
        })
        .when('/my-portfolio', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/my-portfolio.html",
            controller: "portfolioController"
        })
        .when('/user-fund/:adviser/:fund/:investMode', {
            redirectTo: "/user-wealthbasket/:adviser/:fund"
        })
        .when('/user-wealthbasket/:adviser/:fund/:investMode', {
            redirectTo: "/user-wealthbasket/:adviser/:fund"
        })
        .when('/user-fund/:adviser/:fund', {
            redirectTo: "/user-wealthbasket/:adviser/:fund"
        })
        .when('/user-wealthbasket/:adviser/:fund', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/user-fund.html",
            controller: "UserFundController"
        })
        .when('/fund-revision', {
            redirectTo: "/wealthbasket-revision"
        })
        .when('/wealthbasket-revision', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/fund-revision.html",
            controller: "FundRevisionController"
        })
        .when('/notifications', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/notifications.html",
            controller: "NotificationsController"
        })
        .when('/disclosure', {
            templateUrl: "views/disclosure.html",
            controller: "DisclosureController"
        })
        .when('/risk-profile', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/risk-profiler.html",
            controller: "RiskProfillerController"
        })
        .when('/order-placement', {
            resolve: {
                auth: authCheckAndHandler
            },
            templateUrl: "views/order-placement.html",
            controller: "orderPlacementController"
        })
        .when('/sitemap', {
            templateUrl: "views/sitemap-generator.html",
            controller: "SiteMapController"
        })
        .otherwise({
            templateUrl: "views/not-found.html"
        });

}]);

app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.useXDomain = true;
    delete $httpProvider.defaults.headers.common['X-Requested-With'];
}]);

app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.withCredentials = false;
}]);

app.config(['$qProvider', function ($qProvider) {
    $qProvider.errorOnUnhandledRejections(false);
}]);

app.config(['$httpProvider', function ($httpProvider) {

    $httpProvider.defaults.headers.common = {};
    $httpProvider.defaults.headers.post = {};
    $httpProvider.defaults.headers.put = {};
    $httpProvider.defaults.headers.patch = {};

}]);


app.service('MetaTagsService',
    function MetaTagsService() {
        // Reference from https://oodavid.com/article/angularjs-meta-tags-management/
        var service = this;
        service.setDefaultTags = setDefaultTags;
        service.setTags = setTags;
        service.clearTags = clearTags;
        var defaultTags = {};
        var tagElements = [];

        function setDefaultTags(tags) {
            angular.copy(tags, defaultTags);
            setTags({});
        }

        function setTags(tags) {
            // mergeDefaultTags(tags);
            angular.forEach(tags, function (content, name) {
                var tagElement = getTagElement(content, name);
                document.head.appendChild(tagElement);
                tagElements.push(tagElement);
            });
        }

        function mergeDefaultTags(tags) {
            angular.forEach(defaultTags, function (defaultTagContent, defaultTagName) {
                if (!tags[defaultTagName]) {
                    tags[defaultTagName] = defaultTagContent;
                }
                // else if (defaultTagName === 'title') {
                //     tags['title'] += ' - ' + defaultTagContent;
                // }
            });
            return tags;
        }

        function getTagElement(content, name) {
            if (name == 'title') {
                // Special provision for the title element
                var title = document.createElement('title');
                title.textContent = content;
                return title;
            } else if (name.indexOf('og:') != -1) {
                // Opengraph uses [property]
                var nameAttr = 'property';
                var meta = document.createElement('meta');
                meta.setAttribute(nameAttr, name);
                meta.setAttribute('content', content);
                return meta;
            } else if (name.indexOf('itemprop:') != -1) {
                var nameAttr = 'itemprop';
                var meta = document.createElement('meta');
                meta.setAttribute(nameAttr, name.split(":")[1]);
                meta.setAttribute('content', content);
                return meta;
            } else {
                var nameAttr = 'name';
                var meta = document.createElement('meta');
                meta.setAttribute(nameAttr, name);
                meta.setAttribute('content', content);
                return meta;
            }


        }

        function clearTags() {
            // angular.forEach(tagElements, function(tagElement) {
            //     document.head.removeChild(tagElement);
            // });
            var elements = document.getElementsByTagName("meta");
            for (let index = 0; index < elements.length; index++) {
                let element = elements[index];
                element.remove();
            }
            tagElements.length = 0;
        }
    });

app.run(function ($rootScope, MetaTagsService, seotags) {
    $rootScope.$on('$routeChangeSuccess', function ($event, next, current) {
        MetaTagsService.clearTags();
        let domain = getDomain();
        let page = next.$$route.controller == 'FundDetailsController' ? next.pathParams.fundname : next.$$route.controller;
        const authPages = ['orderPlacementController', 'RiskProfillerController', 'NotificationsController', 'FundRevisionController', 'UserFundController', 'portfolioController', 'ProfileController', 'UploadTradesController', 'OrderBookController', 'UserPerformanceController', 'PaymentController', 'TransactionController', 'RiaAgreementController', 'KycThankuController', 'KycController', 'SubscriptionFlowController'];
        if (domain in seotags.TAGS && page in seotags.TAGS[domain]) {
            seotags.TAGS[domain][page].forEach(key => {
                if (key.metaType == "title") {
                    MetaTagsService.setTags({
                        'title': key.metaValue,
                        'og:title': key.metaValue,
                        'twitter:title': key.metaValue,
                        'itemprop:name': key.metaValue
                    });
                } else if (key.metaName == "description") {
                    MetaTagsService.setTags({
                        'description': key.metaValue,
                        'twitter:description': key.metaValue,
                        'og:description': key.metaValue,
                        'itemprop:description': key.metaValue,
                    });
                }
            })
        } 

        if (authPages.includes(page)) {
            removeRobotsTagElement();
            MetaTagsService.setTags({
                'robots': 'noindex,nofollow',
            });
        } else if (!authPages.includes(page)) {
            removeRobotsTagElement();
            MetaTagsService.setTags({
                'robots': 'index,follow',
            });
        }
    })
});

app.filter('plaintext', function () {
    return function (text) {
        if (text) {
            var normalText = String(text).replace(/<[^>]+>/gm, '');
            return String(normalText).replace('&nbsp;', ' ').replace('&amp;', '&');
        }
        return '';
    };
});

// https: //stackoverflow.com/questions/35598765/inr-currency-format
app.filter('INR', function () {
    return function (input) {
        if (!isNaN(input)) {
            var currencySymbol = '₹';
            var result = input.toString().split('.');

            var lastThree = result[0].substring(result[0].length - 3);
            var otherNumbers = result[0].substring(0, result[0].length - 3);
            if (otherNumbers != '')
                lastThree = ',' + lastThree;
            var output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree; // Adds a comma after every 2 digits and adds last 3 

            if (result.length > 1) {
                output += "." + result[1];
            }

            return currencySymbol + output;
        }
    }
});

//https://stackoverflow.com/questions/18095727/limit-the-length-of-a-string-with-angularjs
app.filter('cut', function () {
    return function (value, wordwise, max, tail) {
        if (!value) return '';

        max = parseInt(max, 10);
        if (!max) return value;
        if (value.length <= max) return value;

        value = value.substr(0, max);
        if (wordwise) {
            var lastspace = value.lastIndexOf(' ');
            if (lastspace !== -1) {
                //Also remove . and , so its gives a cleaner result.
                if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
                    lastspace = lastspace - 1;
                }
                value = value.substr(0, lastspace);
            }
        }

        return value + (tail || ' …');
    };
});

app.directive("compareTo", function () {
    return {
        require: "ngModel",
        scope: {
            repeatPassword: "=compareTo"
        },
        link: function (scope, element, attributes, paramval) {
            paramval.$validators.compareTo = function (val) {
                return val == scope.repeatPassword;
            };
            scope.$watch("repeatPassword", function () {
                paramval.$validate();
            });
        }
    };
});

app.directive('aDisabled', function () {
    return {
        compile: function (tElement, tAttrs, transclude) {
            //Disable ngClick
            tAttrs["ngClick"] = "!(" + tAttrs["aDisabled"] + ") && (" + tAttrs["ngClick"] + ")";

            //return a link function
            return function (scope, iElement, iAttrs) {

                //Toggle "disabled" to class when aDisabled becomes true
                scope.$watch(iAttrs["aDisabled"], function (newValue) {
                    if (newValue !== undefined) {
                        iElement.toggleClass("disabled", newValue);
                    }
                });

                //Disable href on click
                iElement.on("click", function (e) {
                    if (scope.$eval(iAttrs["aDisabled"])) {
                        e.preventDefault();
                    }
                });
            };
        }
    };
});

function removeRobotsTagElement() {
    let elements = document.getElementsByName("robots");
    if (elements.length > 0) {
        console.log("robots elements", elements);
        elements.forEach(element => {
            element.remove();
        });
    }
}
